import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { StarFillHalfIcon, StarFillIcon, StarOutlineIcon } from 'static/icons';

interface Props {
  value: number;
  feedbackCount?: number;
  max?: number;
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const Rating: React.FC<Props> = ({
  value,
  feedbackCount,
  max = 5,
  onClick,
}) => {
  const floor = Math.floor(value);
  const ceil = Math.ceil(value);
  const remainder = value - floor;
  const starsFilled = remainder >= 0.75 ? ceil : floor;
  const starsOutlined = +(remainder > 0 && remainder < 0.25) + max - ceil;
  return value <= max ? (
    <Box
      display="flex"
      onClick={onClick}
      cursor={onClick ? 'pointer' : undefined}
    >
      <Box display="inline-flex" position="relative" alignItems="center">
        {Array.from(Array(starsFilled).keys()).map((_, i) => (
          <StarFillIcon key={String(i)} />
        ))}
        {remainder >= 0.25 && remainder < 0.75 && <StarFillHalfIcon />}
        {Array.from(Array(starsOutlined).keys()).map((_, i) => (
          <StarOutlineIcon key={String(max - i)} />
        ))}
      </Box>
      {typeof feedbackCount !== 'undefined' ? (
        <Text color="grayText" textStyle="body2">
          {`(${feedbackCount})`}
        </Text>
      ) : null}
    </Box>
  ) : null;
};
